module.exports = __webpack_public_path__ + "6a71a16573d395dd7e4d4bbefb4baf5e.pdf";